import { useEffect, useState } from 'react';
import { listProjectMembers } from '../../api/projectMembers';
import { Project } from './types';
import { PROJECTS_CHANGED_EVENT } from './useProjectStore';

export function useProjectMemberCount(
  project: Project,
  isPreviewMode: boolean,
): number | undefined {
  const [liveCount, setLiveCount] = useState<number>();
  // Members are assigned via a separate call from project creation/updates,
  // so this count must refetch whenever that happens too, not just on mount.
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => {
    if (isPreviewMode) return undefined;
    const onProjectsChanged = () => setRefreshTick(tick => tick + 1);
    window.addEventListener(PROJECTS_CHANGED_EVENT, onProjectsChanged);
    return () =>
      window.removeEventListener(PROJECTS_CHANGED_EVENT, onProjectsChanged);
  }, [isPreviewMode]);

  useEffect(() => {
    if (isPreviewMode) return undefined;
    let cancelled = false;
    listProjectMembers(project.id)
      .then(members => {
        if (!cancelled) setLiveCount(members.length);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [isPreviewMode, project.id, refreshTick]);

  return isPreviewMode ? project.members.length : liveCount;
}
